export const SALE_REQUEST = 'SALE_REQUEST';
export const SALE_REQUEST_SUCCESS = 'SALE_REQUEST_SUCCESS';
export const SALE_REQUEST_ERROR = 'SALE_REQUEST_ERROR';
